module.exports = __webpack_public_path__ + "assets/img/nine.03e40590.png";